import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import NetworkManager from "../../app/managers/networkManager";
import { config } from "../../app/utils/config";
import { dynamicSort, showErrorToast, showSuccessToast } from '../../app/utils/helpers';
import { Localize } from '../../app/lang/langs';
import moment from 'moment';

const initialState = {
    list: [],
    allTeams: [],
    myTeam: null,
    selectedTeamsIds: [],
    teamManagers: [],
    editCollabMissionResp: null,
    addTeamManagerResp: null,
    editTeamResp: null,
    removeTeamManagerResp: null,
    collabMissions: null,
    allMissions: [],
    inactiveTeams: [],
}

export const teamsSlice = createSlice({
    name: 'teams',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setSelectedTeams: (state, action) => {
            state.selectedTeamsIds = action.payload
        },
        updateAllTeamsSettings: (state, action) => {
            state.list.map(team => {
                if (action.payload.id == team.id) {
                    team.settings = action.payload.settings
                }
            })
        },
        setTeamManagers: (state, action) => {
            state.teamManagers = action.payload
        },
        seteditCollabMissionResp: (state, action) => {
            state.editCollabMissionResp = action.payload;
        },
        setAddTeamManagerResp: (state, action) => {
            state.addTeamManagerResp = action.payload;
        },
        setEditTeamResp: (state, action) => {
            state.editTeamResp = action.payload;
        },
        setCollabMissions: (state, action) => {
            state.collabMissions = action.payload;
        },
        setInactiveTeams: (state, action) => {
            state.inactiveTeams = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTeams.fulfilled, (state, action) => {
            if (action.payload.responseData) {
                if (action.payload.responseData["teams"]) {
                    let teamsList = []
                    for (const key in action.payload.responseData["teams"]) {
                        let team = action.payload.responseData["teams"][key]
                        let teamData = {
                            value: team["id"],
                            label: team["name"],
                            id: team["id"],
                            localization: team["localization"],
                            id_country: team["id_country"],
                            category: "Vue Manager",
                            lunchBreakDuration: team["lunch_break_duration"],
                            settings: team.settings
                        }
                        teamsList.push(teamData)
                    }
                    teamsList.sort(dynamicSort("label"))
                    state.list = teamsList
                }
                if (action.payload.responseData["allTeams"]) {
                    let teamsList = []
                    for (const key in action.payload.responseData["allTeams"]) {
                        let team = action.payload.responseData["allTeams"][key]
                        teamsList.push({
                            value: team["id"],
                            label: team["name"],
                            frais_transport: team["frais_transport"],
                            forfait_deplacement: team["forfait_deplacement"],
                            lunchBreakDuration: team["lunch_break_duration"],
                            id: team["id"],
                            id_country: team["id_country"],
                            country_name: team["country_name"],
                            client: team["client_name"] || null,
                            localization: team["localization"],
                            settings: team.settings,
                            sous_service: team["sous_service"],
                            vfact: team["vfact"],
                            managers: team["managers"],
                            assets: team["assets"] || [],
                            created_at: team["created_at"]
                        })
                    }
                    teamsList.sort(dynamicSort("label"))
                    state.allTeams = teamsList
                }
                if (action.payload.responseData["myTeam"]) {
                    let team = action.payload.responseData["myTeam"]
                    let teamData = {
                        value: team["id"],
                        label: team["name"],
                        id: team["id"],
                        localization: team["localization"],
                        id_country: team["id_country"],
                        userRoleId: team["userRoleId"],
                        category: team["userRoleId"] == 2 ? "Vue Manager" : "Vue Collab"
                    }
                    state.myTeam = teamData
                }
            }
        })
        builder.addCase(addRemoveMembers.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast(action.payload.responseData.message);
            }
        })
        builder.addCase(getTeamsManagers.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.teamManagers = action.payload.responseData.managers
            }
        })
        builder.addCase(getCollabMissions.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.collabMissions = action.payload.responseData
            }
        })
        builder.addCase(getAllMissions.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                let missionsList = action.payload.responseData?.missions

                state.allMissions = missionsList.map(m=>{
                    return{
                        ...m,
                        start_date: m.start_date ? moment(m.start_date).toDate() : null,
                        end_date: m.end_date ? moment(m.end_date).toDate() : null
                    }
                })
            }
        })
        builder.addCase(editCollabMission.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.editMemberResp = action.payload.responseData;
            }
        })
        builder.addCase(addTeamManager.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast(action.payload.responseData.message);
                state.addTeamManagerResp = action.payload.responseData;
            }
        })
        builder.addCase(editTeam.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.editTeamResp = action.payload.responseData;
            }
        })
        builder.addCase(addTeam.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast(action.payload.responseData.message);
            }
        })
        builder.addCase(removeTeamManager.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast(action.payload.responseData.message);
                state.removeTeamManagerResp = action.payload.responseData;
            }
        })
        builder.addCase(changeTeamActiveStatus.fulfilled, (state, action) => {
            // if (action.payload.responseData && action.payload.responseData.status) {
            //     showSuccessToast(Localize(action.payload.responseData.message));
            // }else if(action.payload.responseData && !action.payload.responseData.status) {
            //     showErrorToast(Localize(action.payload.responseData.message));
            // }
        })
        builder.addCase(getInActiveTeams.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.inactiveTeams = action.payload.responseData.teams || [];
            } else if (action.payload.responseData && !action.payload.responseData.status) {
                showErrorToast(Localize(action.payload.responseData.message));
            }
        })
    },
})

export const getTeams = createAsyncThunk(
    'planning/getTeams',
    async () => {
        try {
            let response = await NetworkManager.getInstance().getRequest(config.apiPaths.planning.getTeams)
            return response
        } catch (error) {
            return error
        }
    }
)

export const updateCollabsOrder = createAsyncThunk(
    'planning/updateCollabsOrder',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.planning.updateCollabsOrder, body)
            return response
        } catch (error) {
            return error
        }
    }
)

export const addRemoveMembers = createAsyncThunk(
    'teams/addRemoveMembers',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.teams.addRemoveMembers, body)
            return response
        } catch (error) {
            return error
        }
    }
)
export const getTeamsManagers = createAsyncThunk(
    'teams/getTeamsManagers',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.teams.getTeamsManagers, body)
            return response
        } catch (error) {
            return error
        }
    }
)
export const addTeam = createAsyncThunk(
    'teams/addTeam',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance()
                .postRequest(config.apiPaths.teams.addTeam, body)
            return response
        } catch (error) {
            return error
        }
    }
)

export const getCollabMissions = createAsyncThunk(
    'teams/getCollabMissions',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.teams.getCollabMissions, body)
            return response
        } catch (error) {
            return error
        }
    }
)

export const getAllMissions = createAsyncThunk(
    'teams/getAllMissions',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.teams.getAllMissions, body)
            return response
        } catch (error) {
            return error
        }
    }
)

export const editCollabMission = createAsyncThunk(
    "teams/editCollabMission",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.editCollabMission,
                body
            );
            if (response.responseData && response.responseData.status) {
                showSuccessToast(response.responseData.message);
            }
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const addCollabMission = createAsyncThunk(
    "teams/addCollabMission",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.addCollabMission,
                body
            );
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const deleteCollabMission = createAsyncThunk(
    "teams/deleteCollabMission",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.deleteCollabMission,
                body
            );
            if (response.responseData && response.responseData.status) {
                showSuccessToast(response.responseData.message);
            }
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const addTeamManager = createAsyncThunk(
    "teams/addTeamManager",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.addTeamManager,
                body
            );
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const editTeam = createAsyncThunk(
    "teams/editTeam",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.editTeam,
                body
            );
            return response;
        } catch (error) {
            return error;
        }
    }
)

export const removeTeamManager = createAsyncThunk(
    "teams/removeTeamManager",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.removeTeamManager,
                body
            );
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const editCollabProfile = createAsyncThunk(
    "teams/editCollabProfile",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.editCollabProfile,
                body
            )
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const changeTeamActiveStatus = createAsyncThunk(
    "teams/changeTeamActiveStatus",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.changeTeamActiveStatus,
                body
            );
            if (response.responseData && response.responseData.status) {
                //showSuccessToast(response.responseData.message);
            }
            return response;
        } catch (error) {
            return error;
        }
    }
);


export const getInActiveTeams = createAsyncThunk(
    "teams/getInActiveTeams",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.teams.getInActiveTeams,
                body
            );
            if (response.responseData && response.responseData.status) {
                //showSuccessToast(response.responseData.message);
            }
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const {
    setSelectedTeams,
    updateAllTeamsSettings,
    setTeamManagers,
    setEditTeamResp,
    setCollabMissions,
    setInactiveTeams
} = teamsSlice.actions

export default teamsSlice.reducer